/** Xem giải thích tại `a11y.messages.en.ts`. */
export const a11yMessagesVi = {
    "a11y.chart.symbol": "Mã",
    "a11y.chart.timeframe": "Khung thời gian",
    "a11y.chart.ohlc": "OHLC",
    "a11y.chart.bars": "Số nến",
    "a11y.chart.visibleRange": "Vùng hiển thị",
    "a11y.chart.status": "Trạng thái",
    "a11y.chart.noData": "Chưa có dữ liệu",
};
